



















































import {Component} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';
import {Option} from '@/models';

import storeOption from '@/stores/modules/option';

import InputDatePicker from '@/components/Input/DatePicker.vue';

@Component({
	components: {
		InputDatePicker,
	}
})
export default class CrudOptionEdit extends AbstractEditVue<Option> {
	public constructor() {
		super(
			storeOption,
			'Option modifié',
			'Option ajouté',
		);
	}
}
